import React from "react";
import { useNavigate } from "react-router-dom";

const LastLocation = () => {
  const navigate = useNavigate();

  const goBack = () => {
    const lastLoc = localStorage.getItem("lastLocation");
    if (lastLoc) {
      navigate(lastLoc);
    }
  };

  return <i className="bi bi-arrow-left" onClick={goBack}></i>;
};

export default LastLocation;
